































import Vue from 'vue';
import { Component, Prop, PropSync } from 'vue-property-decorator';
import PaginationInterface from '@core/interfaces/pagination-interface';

@Component({
  name: 'bpc-table-header-pagination',
  components: {},
})
export default class TableHeaderPagination extends Vue {
  // PROPS

  @PropSync('pagination', { type: Object }) syncedPagination!: PaginationInterface;
  @Prop({ type: Array, default: () => [5, 10, 15, 20, 50, 100, 200] })
  readonly pageOptions: number[];

  // DATA
  // LIFECYCLE
  // created() { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  // COMPUTED

  // METHODS

  nextPage() {
    this.syncedPagination.current_page = Math.min(
      this.syncedPagination.current_page + 1,
      this.syncedPagination.last_page,
    );
  }
  prevPage() {
    this.syncedPagination.current_page = Math.max(this.syncedPagination.current_page - 1, 1);
  }
  changePerPage() {
    this.syncedPagination.current_page = 1;
  }

  // WATCHERS
}
